<template>
  <div class="network-page">
    <app-page-header title="Redes">
      <button @click="create()" v-app-button.icon-left>
        <b-icon size="is-small" icon="plus" />Novo
      </button>
    </app-page-header>

    <network-table></network-table>
  </div>
</template>

<script>
import NetworkTable from '@/components/Tables/NetworkTable.vue';

export default {
  name: 'network-page',
  components: {
    NetworkTable,
  },
  methods: {
    create() {
      this.$router.push('/network/create');
    },
  },
};
</script>

<style lang="scss" scoped></style>
